import { CellContentType } from '../../../../shared/components/table/models/cellContent.model';
import { TableHeaders } from '../../../../shared/components/table/models/tableHeaders.model';

export const ConfigurationSizeTableHeaders: TableHeaders[] = [
  {
    key: 'name',
    label: 'Container',
    content: {
      maxLength: 5,
      type: CellContentType.Text
    }
  },
  {
    key: 'save',
    label: '',
    content: {
      type: CellContentType.Button,
      label: 'Save'
    },
    disabledCondition: ({ name }) => !name?.length
  },
  {
    key: 'active',
    label: ' ',
    content: {
      type: CellContentType.Switcher
    }
  }
];
